// The bill's due date from the vendor's payment terms (Stephanie 2026-10-20).
// useTermsDueDate fills the Due date box from the terms until someone types
// their own; TermsDueHint says where the date came from. Unclear terms leave
// it blank (never a guess) — the server does the same for a blank due date.
import { useEffect, useState } from "react";
import { dueDateFromTerms, parseVendorTerms } from "@merchd/shared";

export function useTermsDueDate(billDate: string, terms: string | null | undefined) {
  const [dueDate, setDue] = useState("");
  const [typed, setTyped] = useState(false);
  useEffect(() => {
    if (!typed) setDue(dueDateFromTerms(billDate, terms) ?? "");
  }, [billDate, terms, typed]);
  const setDueDate = (v: string) => {
    setTyped(true);
    setDue(v);
  };
  return { dueDate, setDueDate, fromTerms: !typed && dueDate !== "" };
}

export function TermsDueHint({ vendorName, terms, fromTerms }: { vendorName: string | null; terms: string | null | undefined; fromTerms: boolean }) {
  if (!vendorName) return null;
  const p = parseVendorTerms(terms);
  if (p.kind === "unknown") {
    return (
      <span className="mt-1 block text-xs text-muted">
        {p.label ? `${vendorName}'s terms ("${p.label}") don't give a date — type it in.` : `No payment terms on file for ${vendorName} — type the due date.`}
      </span>
    );
  }
  return fromTerms ? <span className="mt-1 block text-xs text-muted">From {vendorName}&apos;s terms: {p.label}.</span> : null;
}
